module.exports = __webpack_public_path__ + "img/img19.997286e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img19.jpg
// module id = 364
// module chunks = 0